export default "__VITE_ASSET__DS_BJJ05__"